'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_ROOMS = exports.FETCH_ROOMS_ERROR = exports.FETCH_ROOMS_SUCCESS = exports.FETCH_ROOMS_BEGIN = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.fetchBegin = fetchBegin;
exports.set = set;
exports.clear = clear;
exports.setErrors = setErrors;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_ROOMS_BEGIN = exports.FETCH_ROOMS_BEGIN = 'FETCH_ROOMS_BEGIN';
var FETCH_ROOMS_SUCCESS = exports.FETCH_ROOMS_SUCCESS = 'FETCH_ROOMS_SUCCESS';
var FETCH_ROOMS_ERROR = exports.FETCH_ROOMS_ERROR = 'FETCH_ROOMS_ERROR';
var CLEAR_ROOMS = exports.CLEAR_ROOMS = 'CLEAR_ROOMS';

var initialState = {
  isLoading: false,
  // errors: [
  //   {
  //     code: 'param_required',
  //     field: 'subdivision'
  //   },
  //   {
  //     code: 'param_invalid',
  //     field: 'subdivision',
  //     message: ''
  //   },
  //   {
  //     code: 'xxx',
  //     title: 'xxx',
  //     message: ''
  //   }
  // ]
  errors: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case FETCH_ROOMS_BEGIN:
      return (0, _extends3.default)({}, state, { isLoading: true });
    case FETCH_ROOMS_SUCCESS:
      return (0, _extends3.default)({}, initialState, action.rooms);
    case CLEAR_ROOMS:
      return (0, _extends3.default)({}, initialState);
    case FETCH_ROOMS_ERROR:
      return (0, _extends3.default)({}, initialState, { errors: action.errors });
    default:
      return state;
  }
}

// TODO: move the fetching logic to here
// export function fetchRooms() {}

function fetchBegin() {
  return {
    type: FETCH_ROOMS_BEGIN
  };
}

function set(rooms) {
  return {
    type: FETCH_ROOMS_SUCCESS,
    rooms: rooms
  };
}

function clear() {
  return {
    type: CLEAR_ROOMS
  };
}

function setErrors(errors) {
  return {
    type: FETCH_ROOMS_ERROR,
    errors: errors
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/rooms.js
// module id = 283
// module chunks = 0